const socialMediaGlobal = {
  config: {
    general: {
      socialChannels: {
        facebook: {
          label: "facebook",
          url: "https://en.wikipedia.org/wiki/Facebook",
        },
        x: {
          label: "x",
          url: "https://en.wikipedia.org/wiki/Twitter",
        },
        instagram: {
          label: "instagram",
          url: "https://en.wikipedia.org/wiki/Instagram",
        },
        linkedin: {
          label: "linkedin",
          url: "https://en.wikipedia.org/wiki/LinkedIn",
        },
        youtube: {
          label: "youtube",
          url: "https://en.wikipedia.org/wiki/YouTube",
        },
        xing: {
          label: "xing",
          url: "https://en.wikipedia.org/wiki/XING",
        },
      },
    },
  },
};

export default socialMediaGlobal;
